import { GAME_FACT_SOCCER_SECONDYELLOWCARD, GAME_FACT_SOCCER_YELLOWCARD } from "../constants";

export const isSecondYellowForPlayer = (facts, { teamId, playerId }) => {
  if (!playerId || !teamId) return false;

  let yellows = 0;

  for (const f of facts ?? []) {
    // ignore l’élément en cours s’il est déjà dans la liste
    const type = f?.type;
    const player = f?.detail?.player;
    const team = f?.detail?.team;

    const isYellow =
      type === GAME_FACT_SOCCER_YELLOWCARD ||
      type === GAME_FACT_SOCCER_SECONDYELLOWCARD;

    if (isYellow && player === playerId && team === teamId) {
      
      yellows += 1;
      //TODO se baser sur la date de création si la plus vieille est celle du GF actuel, alors on stop la boucle pour éviter de flaguer le 1er jaune

      if (yellows >= 2) return true; // déjà expulsé
    }
  }
  
  return yellows >= 1; // 1 jaune existant → le prochain sera le 2e
};

// createdDate
// : 
// "2025-10-13T10:17:08.477Z"
// creation
// : 
// "2025-10-13T10:17:08.472Z"
// detail
// : 
// buteur
// : 
// ""
// droper
// : 
// ""
// edited
// : 
// false
// inplayer
// : 
// ""
// opponent
// : 
// ""
// outplayer
// : 
// ""
// passeur
// : 
// ""
// penaliter
// : 
// ""
// period
// : 
// 2
// player
// : 
// "63bd220f3a17eacca4bab4a5"
// reason
// : 
// "contestation"
// shoter
// : 
// ""
// team
// : 
// "63a48f733a17eacca4b1dc16"
// text
// : 
// "carton jaune pour Cajuste! Raison : Contestation."
// timer
// : 
// 0
// title
// : 
// "CARTON JAUNE"
// transformer
// : 
// ""
// [[Prototype]]
// : 
// Object
// idMatch
// : 
// "63a48f773a17eacca4b1dd5f"
// lastModifiedDate
// : 
// "2025-10-13T10:17:08.477Z"
// type
// : 
// "soccer_yellowcard"
// version
// : 
// "gameFactV1"
// versionModel
// : 
// "v1"